import { trackAuctionErrorPopupShow } from './tracking';
import { showNotification } from './showNotification';

export function showFailNotification(retryCb: () => Promise<void>) {
  trackAuctionErrorPopupShow();

  showNotification({
    status: 'failed',
    onRetryClick: retryCb,
  });
}
